import React from "react";
import styles from "./ImageInput.module.scss";
import UploadHelper from "../../helpers/upload";

const ImageInput = ({
  allowMultiSelect,
  onImageSelect,
  setLoading = () => {},
  children
}) => {
  const inputId = `imageInput${Math.random()}`;

  const onImageChange = async (event) => {
    setLoading(true);
    const files = Array.from(event.target.files);
    const hasSelectedFile = files.length > 0;
    if (hasSelectedFile) {
      const uploadPromises = files.map(async (file) => {
        const { url, signedUrl } = await UploadHelper.getSignedUrl(
          UploadHelper.PRODUCT_IMAGE,
          {
            contentType: file.type
          }
        );

        await UploadHelper.uploadToS3(signedUrl, file, () => {});
        return url;
      });

      const resolvedImages = await Promise.all(uploadPromises);
      onImageSelect(allowMultiSelect ? resolvedImages : resolvedImages[0]);
    }
    setLoading(false);
  };

  return (
    <>
      <label htmlFor={inputId}>{children}</label>
      <input
        className={styles.hiddenInput}
        type="file"
        multiple={allowMultiSelect}
        accept="image/*"
        required
        id={inputId}
        onChange={onImageChange}
      />
    </>
  );
};

export default ImageInput;
